import React, { Component } from "react";


import Join from "../../images/icon-join-the-club.svg";
import Drive from "../../images/icon-drive-traffic.svg";
import GetPaid from "../../images/icon-get-paid.svg";
import Commission1 from "../../images/icon-25.svg";
// import Commission2 from "../../images/icon-30.svg";
// import Commission3 from "../../images/icon-35.svg";



class HowItWorks extends Component {
  render() {
    return (
        <section className="clearfix fadeInUp how">
          <div className="container">
            <div className="title-1">How It Works</div>
            <div className="content">
              <p>
                Make operating and UI smooth and easy with provided financial solutions and smart interface.
              </p>
            </div>
            <div className="row">
              <div className="col">
                <img
                  src={Join}
                  title="Join Us"
                  alt="Join Us"
                />
                <h2>Join Us</h2>
                <p>
                  Complete our form to create your account, which does not take more than 5 minutes.
                </p>
              </div>
              <div className="col">
                <img
                  src={Drive}
                  title="Get the Traffic Running"
                  alt="Get the Traffic Running"
                />
                <h2>Get the Traffic Running</h2>
                <p>
                  Edit and personalise your arsenal of marketing tools with the wide selection provided.
                </p>
              </div>
              <div className="col">
                <img src={GetPaid} title="Collect Your Revenue Share" alt="Collect Your Revenue Share" />
                <h2>Collect Your Revenue Share</h2>
                <p>
                  At the end of each month, you will get paid for the players you have driven to us.
                </p>
              </div>
            </div>
          </div>
          <div className="container commissions">
            <div className="title-2">
              <span>The Easy Way to Earn Commission</span>
              Commissions Plan
            </div>
            <div className="row">
              <div className="col">
                <h4>£0 – £10,000</h4>
                <span>
                  Monthly Net Revenue* of the customers You send to us
                </span>
                <p>You will be paid with</p>
                <div className="relative">
                  <img
                    src={Commission1}
                    title="25% Total Earnings"
                    alt="25% Total Earnings"
                  />
                  <div className="text">25%</div>
                </div>
                <div className="rate">
                  <span>20% Net Revenue Share</span>
                  <span>5% Commission Booster</span>
                </div>
                <span>
                  applies when 20+ new depositing players are directed within the month
                </span>
                <h3>25% Total Earnings</h3>
              </div>
            </div>
            <div className="align-center">
              <a
                href="https://partners.stechaffiliates.com/login.asp"
                title="Start Earning Today"
                className="start-earning"
              >
                Start Earning Today
              </a>
            </div>
          </div>
        </section>
    );
  }
}

export default HowItWorks
